// src/components/Partners.tsx 
import Frame from "../assets/Frame.jpg";
import valuedPartner from "../assets/valuedPartner.png";

const Partners = () => {
  return (
    <div className="m-auto px-4 sm:px-6 md:px-16 lg:px-36 py-16 sm:py-20 lg:py-28 bg-white flex flex-col lg:flex-row justify-center items-center gap-8 sm:gap-12 lg:gap-20">
      {/* Left side */}
      <div className="flex-1 flex flex-col gap-4 sm:gap-6 text-center lg:text-left order-2 lg:order-1">
        <h2 className="w-full lg:w-[530px] text-zinc-700 text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-wide leading-tight font-['IBM_Plex_Sans']">
          Our Valued Partners
        </h2>
        <p className="text-gray-700 text-base sm:text-lg lg:text-xl leading-relaxed tracking-tight max-w-2xl lg:max-w-none font-['Nunito Sans']">
          Senpiper partners with top global technology leaders to deliver
          integrated, world-class data analytics solutions bringing cutting-edge
          capabilities, scalable infrastructure, and deep industry expertise
          tailored to your enterprise.
        </p>
      </div>

      {/* Right side (single imported image) */}
      <div className="flex-1 w-full lg:w-[366px] flex justify-center lg:justify-end order-1 lg:order-2">
        <img 
          src={valuedPartner} 
          alt="Partner logos"
          className="w-full max-w-sm lg:max-w-none h-auto object-contain"
        />
      </div>
    </div>
  );
};

export default Partners;
